import {ContentHints} from '@/components/app/hint';
import {cn} from '@/lib/utils';
import {Icon} from '../../../app/components/Icon';
import {useNetworkStatus} from '../hooks/useNetworkStatus';
export interface NetworkStatusIconProps {
  className?: string;
  isVisible?: (options: {isOffline: boolean; isSlow: boolean}) => boolean;
}
export const NetworkStatusIcon = ({className, isVisible}: NetworkStatusIconProps) => {
  const {isOffline, isSlow} = useNetworkStatus();
  const visible =
    isVisible == null ||
    isVisible({
      isOffline,
      isSlow,
    });
  if (!visible) {
    return null;
  }
  return (
    <div className={className} id={'network-status-icon'}>
      <Icon
        className={cn({
          'text-red-400': isOffline,
          'text-yellow-400': isSlow,
          'text-green-400': !isOffline && !isSlow,
        })}
        icon={'wifi'}
      />
      <ContentHints side={'left'} target={'#network-status-icon'}>
        {isOffline && 'No internet connection.'}
        {isSlow && 'Slow internet connection.'}
        {!isOffline && !isSlow && 'Good internet connection.'}
      </ContentHints>
    </div>
  );
};
